import { type Enum } from '@webapp/infrastructure/types/Enum'

export const UnitsOfDistance = {
  KILOMETERS: 'km',
  MILES: 'mi',
} as const

export type UnitOfDistanceEnum = Enum<typeof UnitsOfDistance>
